import { Button } from "@shopify/polaris"
import React from "react"
import { useTranslation } from "react-i18next"

export const UpdatePaymentMethod = ({ activeSubscription }) => {
	const { t } = useTranslation()

	return (
		<Button
			fullWidth
			onClick={() =>
				window.open(activeSubscription.updatePaymentMethodUrl, "_blank")
			}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "0.3rem",
					alignItems: "center",
					paddingBottom: "0.3rem",
				}}
			>
				<div>
					<svg
						style={{ height: "2rem", width: "2rem", color: "#333" }}
						viewBox="0 0 24 24"
					>
						<path
							fill="currentColor"
							d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2m-1 14H5c-.55 0-1-.45-1-1v-5h16v5c0 .55-.45 1-1 1m1-10H4V7c0-.55.45-1 1-1h14c.55 0 1 .45 1 1z"
						></path>
					</svg>
				</div>
				<div
					style={{
						display: "flex",
						gap: "0.3rem",
						alignItems: "center",
					}}
				>
					<span style={{ fontSize: "0.85rem" }}>
						{t("account.update_payment_method")}
					</span>
					{/* <svg style={{ display: "block", height: "1rem", width: "1rem", color: "#333" }} viewBox="0 0 24 24"><path fill="currentColor" d="M19 17.975v-.136c1.174-.49 2-1.649 2-3V6.25A3.25 3.25 0 0 0 17.75 3h-8.5a3.251 3.251 0 0 0-3.093 2.25h-.201c-.912 0-1.688.321-2.222.954C3.216 6.817 3 7.634 3 8.5v8.75c0 1.06.383 2.014 1.11 2.7c.726.683 1.733 1.045 2.89 1.045h3.92l4.076.005h.002c.976.005 1.943-.2 2.693-.68c.78-.5 1.309-1.295 1.309-2.345ZM5.956 6.75H6v8.088a3.25 3.25 0 0 0 3.25 3.25h8.246c-.032.418-.242.73-.614.968c-.433.278-1.09.448-1.878.444H15l-4.082-.005H7c-.843 0-1.46-.26-1.86-.637c-.398-.374-.64-.918-.64-1.608V8.5c0-.635.16-1.067.38-1.329c.205-.242.532-.421 1.076-.421Zm6.066-.25h4.728a.75.75 0 0 1 .75.75v4.729a.75.75 0 0 1-1.5 0V9.06l-5.22 5.22a.75.75 0 1 1-1.06-1.061L14.94 8h-2.918a.75.75 0 1 1 0-1.5Z"></path></svg> */}
				</div>
			</div>
		</Button>
	)
}
